'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useTheme } from './ThemeProvider';

const navLinks = [
  { label: 'Beranda', href: '/' },
  { label: 'CNC Router', href: '/cnc-router' },
  { label: 'Tentang Kami', href: '/about' },
  { label: 'Galeri Workshop', href: '/galeri' },
  { label: 'Kontak', href: '/contact' },
];

export default function Header() {
  const pathname = usePathname();
  const { theme, toggleTheme } = useTheme();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Tutup menu otomatis jika pindah halaman
  useEffect(() => {
    setMobileOpen(false);
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-[100] pointer-events-none transition-all duration-300 ${
          scrolled || mobileOpen ? 'bg-card shadow-medium' : 'bg-card'
        } border-b border-border`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center h-20 md:h-24 pointer-events-auto">
          <div className="flex items-center flex-1">
            <Link href="/" className="flex items-center flex-shrink-0 mr-16">
              <Image
                src="/assets/images/app_logo.png"
                alt="Logo IndoCuttingLaser"
                width={220}
                height={80}
                className="w-auto h-10 md:h-16 object-contain"
                priority
              />
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-10 lg:gap-14">
              {navLinks.map((link) => {
                const isActive =
                  pathname === link.href || (link.href !== '/' && pathname.startsWith(link.href));
                return (
                  <Link
                    key={link.href}
                    href={link.href}
                    className={`nav-link-underline text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                      isActive
                        ? 'text-accent active'
                        : 'text-muted-foreground hover:text-foreground'
                    }`}
                  >
                    {link.label}
                  </Link>
                );
              })}
            </nav>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://wa.me/628132282297"
              className="hidden sm:inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-green-600 text-white text-sm font-bold shadow-md hover:bg-green-500 transition-all"
            >
              WhatsApp
            </a>

            {/* Tombol Hamburger */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground z-[110]"
              aria-label="Toggle Menu"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                className="w-6 h-6"
              >
                <path d={mobileOpen ? 'M18 6L6 18M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} />
              </svg>
            </button>
          </div>
        </div>

        {/* --- MOBILE MENU OVERLAY (FIXED VERSION) --- */}
        <div
          className={`md:hidden absolute top-20 left-0 w-full bg-card border-b border-border transition-all duration-300 ease-in-out overflow-hidden 
            ${
              mobileOpen
                ? 'max-h-[400px] opacity-100 visible pointer-events-auto'
                : 'max-h-0 opacity-0 invisible pointer-events-none' // Tambahin invisible & pointer-events-none
            }`}
        >
          <nav className="flex flex-col p-4 gap-2">{/* ... link nav lo ... */}</nav>
          <nav className="flex flex-col p-4 gap-2">
            {navLinks.map((link) => {
              const isActive = pathname === link.href;
              return (
                <Link
                  key={link.href}
                  href={link.href}
                  className={`px-4 py-3 rounded-lg text-base font-medium transition-colors ${
                    isActive
                      ? 'bg-accent/10 text-accent'
                      : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <a
              href="https://wa.me/628132282297"
              className="mt-2 flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-green-600 text-white font-bold"
            >
              WhatsApp Kami
            </a>
          </nav>
        </div>
      </header>

      <div className="h-20 md:h-24" />
    </>
  );
}
